module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rachmaninoff wrote a love song with a soaring, passionate vocal line, and then tenderness in the last words “do you remember?”. These words work better in the Russian version of the song, and indeed the whole song works better in Russian. There is a good recording of the song in French (but only one) by the tenor Sergej Larin. Everyone else sings the song in Russian. The tempo is not indicated in the manuscript and the editor has marked it “Moderato,” which gives performers some room for interpretation. The recordings vary, with a fleet performance by Elisabeth Söderström in just over two minutes, and a much slower, beautifully articulated reading of the song as an anthem of love by the baritone Pavel Lisitsian that is just under three minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rachmaninoff added two words to the French original and repeated a few phrases, which I have enclosed in brackets below.")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Russian translation was made by the Soviet poet Veronika Tushnova (1915–65) when the song was first published in 1947.")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("T")]), _vm._v("EXT")], 1), _vm._v(". "), _c('b', [_vm._v("Edouard Pailleron")]), _vm._v(", published 1889 ("), _c('i', [_vm._v("Pailleron")]), _vm._v(", pp. 27-8). Title: “Chanson.” Russian translation by "), _c('b', [_vm._v("Veroníka Tushnóva")]), _vm._v(". Not set by any other composers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("M")]), _vm._v("ETER")], 1), _vm._v(". Mixed ternary and binary lines, but the first line, an amphibrach, sets up the dominant ternary pattern of the lines. This underlying ternary rhythm is heard in the triplets of the voice part and in the piano part throughout the song.")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("M")]), _vm._v("USIC")], 1), _vm._v(". Dated 1 April 1891. Without opus number. E-flat Major. 3/4, Moderato. For High Voice: d"), _c('sup', [_vm._v("1")]), _vm._v("–a"), _c('sup', [_vm._v("2")]), _vm._v(" flat. First published posthumously in "), _c('i', [_vm._v("Lamm")]), _vm._v(", 1947. No dedication.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("R")]), _vm._v("ECORDINGS")], 1), _vm._v(". Gedda, Kharitonov, Larin (in French), Lisitsian, Naoumenko, Söderström, Suchkova.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "chtop",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "3%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "87%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chno"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('td'), _c('td', [_c('p', {
    staticClass: "cht"
  }, [_c('i', [_vm._v("C’était en avril")])]), _vm._v(" "), _c('p', {
    staticClass: "cht"
  }, [_c('i', [_vm._v("It was in April")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rachmaninoff found this French lyric in "), _c('i', [_vm._v("Amours et haines")]), _vm._v(" (Loves and Hates, 1889) by Édouard Pailleron (1834–99), author of comedies and editor of "), _c('i', [_vm._v("Revue des Deux Mondes")]), _vm._v(". He was not well known in Russia, and I have not found any other Russian songs that use lyrics by him.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_vm._v("The song is dated 1 April 1891, soon after Rachmaninoff’s eighteenth birthday. Spring—the coming of spring, sudden joy, and first love—was one of his favorite themes. He went on to write a cantata for baritone, chorus, and orchestra to a famous Nekrasov poem about the “verdant noise” of spring’s coming (“Spring,” Op. 20, 1902); and several of his best songs are celebrations of spring (Song 32 “Spring waters,” Song 38 “Lilacs,” and Song 56 “Before my window”). In the case of this early song, the French lyric is pretty in a conventional way but pale and precious compared to Aleksey Tolstoy’s exuberant celebration of spring which Tchaikovsky made into one of his most well-known songs (“In early spring,” Song 40 in "), _c('i', [_vm._v("TCS")]), _vm._v("). The theme, however, is exactly the same: looking back and remembering the happiness of a spring morning which was also the morning of love.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "top",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "45%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("C’était en avril, un dimanche,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("It was in April, a Sunday")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Oui, le dimanche!")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Yes, on Sunday!")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("J’étais heureux…")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("I was happy…")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Vous aviez une [jolie] robe blanche")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("You wore a [pretty] white dress")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Et deux gentils brins de pervenche,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("And two nice sprigs of periwinkle,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Oui, de pervenche,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Yes, periwinkle,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Dans les cheveux")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("In your hair")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("[brins de pervenche].")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("[sprigs of periwinkle].")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Nous étions assis sur la mousse,")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("We were sitting on the moss,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Oui, sur la mousse,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Yes, on the moss,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Et sans parler,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("And without speaking,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Nous regardions l’herbe, [l’herbe]")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("We looked at the grass, [the grass]")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("qui pousse,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("that grows,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("[Et] la feuille verte, et l’ombre douce,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("[And] the green leaf, and the soft shade,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Oui, l’ombre douce,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Yes, the soft shade,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Et l’eau couler.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("And the rippling water.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("Un oiseau chantait sur la branche,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("A bird was singing on a branch,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Oui, sur la branche,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Yes, on a branch,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Puis il s’est tu,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Then it was silent,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("J’ai pris dans ma main ta main blanche…")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("In my hand I took your white hand…")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("C’était en avril, un dimanche,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("It was in April, a Sunday")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Oui, le dimanche…")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Yes, on Sunday…")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("T’en souviens-tu?")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Do you remember it?")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "top",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "45%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "30%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Апрель! Вешний праздничный день")]), _vm._v(",")])]), _c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("да, вешний день!.. Луга в росе.")])])]), _c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Ты пришла в белом платье своём")])])]), _c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("и два подснежника в косе")]), _vm._v(",")])]), _c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("да, два цветка, два цветка в тёмной косе.")])])]), _c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("И без слов мы сели на мох, бархатный мох;")])])]), _c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("в блеске лучей весь мир зеленел")]), _vm._v(",")])]), _c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("каждый листок влагой блестел")]), _vm._v(",")])]), _c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("в лёгкой тени, где-то у ног")]), _vm._v(",")])]), _c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("журчал ручей…")])])]), _c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("А в кустах звенел голосок")])])]), _c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("птички лесной. Руки твои")])])]), _c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("в своих я так бережно сжал")])])]), _c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("в то ясное утро, весной")]), _vm._v(",")])]), _c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("светлой весной… Помнишь, помнишь?")])])]), _c('td')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "top",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "45%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Aprél’! Véshnij práznichnyj dén’,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("April! a festive spring day,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Da, véshnij dén’!..")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Yes, a spring day!..")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Lugá v rasé.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Dew lay on the meadows.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Ty prishlá v bélam plát’je svajóm")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("You came in your white dress")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("i dva patsnézhnika f kasé,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("with two snowdrops in your braid,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("da, dva tsvetká, dva tsvetká")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("yes, two flowers, two flowers")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("f tjómnaj kasé.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("in your dark braid.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("I bes slóf my séli na mókh,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("And without words we sat down")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("bárkhatnyj mókh;")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("on the moss, the velvety moss;")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("V bléske luchéj")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("In the bright sunlight")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("ves’ mir zelenél,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("the whole world was green,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("kázhdyj listók vlágaj blestél,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("every leaf was shiny with moisture,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("v ljókhkaj tení,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("and in the light shade,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("gdé-ta u nók,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("somewhere at our feet,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("zhurchál ruchéj…")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("a brook was babbling…")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("A f kustákh zvenél galasók")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("And in the bushes rang out the")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("ptíchki lesnój.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("sweet voice of a little forest bird.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Rúki tvají f svajíkh ja tak")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("I held your hands")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("bérezhna zzhál")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("so tenderly and lovingly")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("f to jásnaje útra, vesnój,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("that clear morning, in the spring,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("svétlaj vesnój… Pómnish,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("in radiant spring… Do you remember,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("pómnish?")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("do you remember?")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "left"
  }, [_c('i', [_vm._v("On Sunday, an April spring day")]), _vm._v(",")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "left1"
  }, [_c('i', [_vm._v("April spring day!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bec06d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/016_Chapter_04.vue
// module id = 102
// module chunks = 0